var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: { show: _vm.showAssignItem, showClose: true },
      on: { selectedItems: _vm.selectedItems, close: _vm.closeModal }
    },
    [
      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
        _vm._v(_vm._s(_vm.getTitle()))
      ]),
      _c(
        "form",
        {
          ref: "AssignClientForm",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.assignItems($event)
            }
          }
        },
        [
          _c("div", { staticClass: "container-fluid " }, [
            _c("div", { staticClass: "row mt-1 " }, [
              _c(
                "div",
                { staticClass: "col-xl-12" },
                [
                  _c("label", { staticClass: "form-control-label" }, [
                    _vm._v(
                      "\n              " + _vm._s(_vm.title) + "\n          "
                    )
                  ]),
                  _c("base-input", {
                    attrs: { "input-classes": "form-control-alternative" },
                    model: {
                      value: _vm.searchTerm,
                      callback: function($$v) {
                        _vm.searchTerm = $$v
                      },
                      expression: "searchTerm"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row mt-1 " }, [
              _c(
                "div",
                { staticClass: "col-xl-12" },
                [
                  _c("search-account-table", {
                    attrs: {
                      showAssignItem: _vm.showAssignItem,
                      searchTerm: _vm.searchTerm,
                      type: _vm.type,
                      isMultipleSelection: _vm.isMultipleSelection,
                      clean: _vm.clean
                    },
                    on: {
                      "item-selected": _vm.selectedItem,
                      cleaned: function($event) {
                        _vm.clean = false
                      },
                      error: _vm.error
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm.isMultipleSelection
            ? _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c("div", { staticClass: "row align-items-center" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 text-right" },
                    [
                      _c(
                        "base-button",
                        {
                          staticClass: "my-4",
                          attrs: { type: "primary", nativeType: "submit" }
                        },
                        [_vm._v("Guardar")]
                      )
                    ],
                    1
                  )
                ])
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }